import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';
import { Pagination, Autoplay, Navigation} from "swiper/modules";

document.addEventListener("DOMContentLoaded", () => {
    initializeSliders()

    initializeGalleryImages()



    if (window.Fancybox) {
        Fancybox.bind('[data-fancybox="gallery"]', {
            Hash: false,
        });
    }



    function initializeSliders() {
        const SliderBanner = new Swiper('.swiper-about-us-gallery', {
            modules: [Pagination, Autoplay, Navigation],
            slidesPerView: 1.1,
            spaceBetween: 16,
            loop: true,
            // autoplay: {
            //     delay: 3000,
            //     disableOnInteraction: false
            // },
            navigation: {
                prevEl: '.js-swiper-gallery-prev-desk',
                nextEl: '.js-swiper-gallery-next-desk',
            },
            pagination: {
                el: '.about-us-gallery__pagination',
                clickable: true,
                // dynamicBullets: true,
            },
            breakpoints: {
                1024: {
                    slidesPerView: 2.5,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 1.6,
                    spaceBetween: 16,
                },
            },
        });
    }




    function initializeGalleryImages() {

        const gallerySwiper = document.querySelector('.swiper-about-us-gallery');
        if (gallerySwiper) {

            const sliders = gallerySwiper.querySelectorAll('.swiper-about-us-gallery__img');
            sliders.forEach((image) => {
                // console.log(image);
                image.classList.add('loaded');
            })
        }
        // const sliderDiv = document.querySelector('.swiper-about-us-gallery');
        // if (sliderDiv) {
        //     sliderDiv.querySelectorAll('.swiper-slide img').forEach((swiperImages) => {
        //         swiperImages.forEach((image) => {
        //             image.classList.add('loaded');
        //         });
        //     });
        // }
    }
});

